function getConfig(env: any) {
  let config
  if (env === 'production') {
    config = {
      apiUrl: 'https://api.linkaumall.com/',
      storeLogoUrl: 'https://s3-ap-southeast-2.amazonaws.com/app.linkaumall.com/storelogo.jpg',
      storeBannerUrl: 'https://s3-ap-southeast-2.amazonaws.com/app.linkaumall.com/banner.png',
      storeMapUrl: 'https://s3-ap-southeast-2.amazonaws.com/app.linkaumall.com/map.jpg',
      industry: '3650d49d-5ace-4806-8380-55b6d143cf17',
      lat: -33.8828318,
      lng: 151.1312018,
      googlePlaceApiKey: 'AIzaSyAyaXfxzi-i5N6m9DYeK6-SHCmJTJqTZuA',
      linkOrderDomain: 'https://order.linkaumall.com/',
      customerRegisiterDomain: 'https://guestbook.linkpos.com.au/#/checkin/',
      firebaseConfig: {
        apiKey: "AIzaSyAIgESsEFOL05wNUxe-7jG5mnENP-QQXGw",
        authDomain: "guestbook-4435e.firebaseapp.com",
        databaseURL: "https://guestbook-4435e.firebaseio.com",
        projectId: "guestbook-4435e",
        storageBucket: "guestbook-4435e.appspot.com",
        messagingSenderId: "980292954409",
        appId: "1:980292954409:web:fe069bf85a2345bf552f38",
        measurementId: "G-FTSRPWP58K"
      },

    }
  } else {
    config = {
      apiUrl: 'https://api.linkpos.com.au/',
      storeLogoUrl: 'https://s3-ap-southeast-2.amazonaws.com/app.linkaumall.com/storelogo.jpg',
      storeBannerUrl: 'https://s3-ap-southeast-2.amazonaws.com/app.linkaumall.com/banner.png',
      storeMapUrl: 'https://s3-ap-southeast-2.amazonaws.com/app.linkaumall.com/map.jpg',
      industry: '53996b4f-1364-4353-8dda-eee5cf644baf',
      lat: -33.8828318,
      lng: 151.1312018,
      googlePlaceApiKey: 'AIzaSyAyaXfxzi-i5N6m9DYeK6-SHCmJTJqTZuA',
      linkOrderDomain: 'https://dev-order.linkpos.com.au/',
      customerRegisiterDomain: 'https://guestbook.linkpos.com.au/#/checkin/',
      firebaseConfig: {
        apiKey: "AIzaSyAIgESsEFOL05wNUxe-7jG5mnENP-QQXGw",
        authDomain: "guestbook-4435e.firebaseapp.com",
        databaseURL: "https://guestbook-4435e.firebaseio.com",
        projectId: "guestbook-4435e",
        storageBucket: "guestbook-4435e.appspot.com",
        messagingSenderId: "980292954409",
        appId: "1:980292954409:web:fe069bf85a2345bf552f38",
        measurementId: "G-FTSRPWP58K"
      },
    }
  }
  return config
}

export default getConfig(process.env.NODE_ENV)
